import { gql } from '@apollo/client';

export const ProjectRdDeterminationFragment = gql`
  fragment ProjectRdDetermination on ProjectRdDetermination {
    id
    isTechnicalInNature
    isTechnicalInNatureSource
    hasQualifiedPurpose
    hasQualifiedPurposeSource
    qualifiedPurposeReasoning
    qualifiedPurposeReasoningSource
    hasTechnicalUncertainties
    technicalInNatureShare
    projectRdDeterminationUncertainties {
      id
      uncertainty
    }
  }
`;
